
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 .667A5.83 5.83 0 00.167 6.5C.167 10.875 6 17.333 6 17.333s5.833-6.458 5.833-10.833A5.83 5.83 0 006 .667zM1.833 6.5C1.833 4.2 3.7 2.333 6 2.333S10.167 4.2 10.167 6.5c0 2.4-2.4 5.992-4.167 8.233C4.267 12.508 1.833 8.875 1.833 6.5zm2.084 0a2.083 2.083 0 114.166 0 2.083 2.083 0 01-4.166 0z","fill":"#000","fill-opacity":".54"}})])
          )
        }
      }
    